import { Typography } from "antd";
import { Link } from "react-router-dom";
import Tooltip from "../Tooltip";

const EllipsisText = ({ title, line = 2, isLink = false, link, limit = 60, target = "_blank", ...rest }) => {
  const DEFAULT_TEXT = "<không có thông tin>";

  const style = {
    display: "-webkit-box",
    WebkitLineClamp: line,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textAlign: title ? undefined : "center",
  };

  const displayText = title || DEFAULT_TEXT;
  // Luôn dùng Typography.Text (thẻ <span>) thay vì Typography.Link (thẻ <a>)
  // để tránh <a> lồng <a> khi component được bọc trong <Link> react-router-dom.
  // Khi link/isLink, tự thêm style màu xanh link + cursor pointer.
  const Content = Typography.Text;
  const linkStyle = isLink || link ? { color: "var(--primary-color, #1890ff)", cursor: "pointer" } : undefined;

  return (
    <div style={style}>
      <Tooltip title={title?.length > limit ? title : undefined}>
        {link ? (
          <Link target={target} to={link}>
            <Content {...rest} style={{ ...linkStyle, ...(rest.style || {}) }}>
              {displayText}
            </Content>
          </Link>
        ) : (
          <Content {...rest} style={linkStyle ?? rest.style}>
            {displayText}
          </Content>
        )}
      </Tooltip>
    </div>
  );
};

export default EllipsisText;
